import i18n, { ResourceLanguage } from "i18next";
import { initReactI18next } from "react-i18next";
import enUS from "./locales/en-US.json";
import roRO from "./locales/ro-RO.json";

interface Resources {
  [key: string]: {
    translation: ResourceLanguage;
  };
}

const resources: Resources = {
  en: { translation: enUS },
  ro: { translation: roRO },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "ro",
  fallbackLng: localStorage.getItem("language") || "ro",
  interpolation: {
    escapeValue: false,
  },
  parseMissingKeyHandler: (key: any) => {
    const parts = key.split(".");
    return parts[parts.length - 1];
  },
});

export default i18n;
